import React from 'react';
import { Avatar, Typography } from 'antd';
import { RobotOutlined, UserOutlined } from '@ant-design/icons';
import { ChatMessage } from '../../types/chat.types';
import './Chat.css';
import { fct } from '../../fct/tokens/tokens';

const { Text } = Typography;

interface MessageBubbleProps {
  message: ChatMessage;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message }) => {
  const isAgent = message.sender === 'agent';

  const formatTime = (date: Date) => {
    return new Date(date).toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="message-bubble-wrapper">
      <div className="message-bubble-header">
        <Avatar
          size="small"
          icon={isAgent ? <RobotOutlined /> : <UserOutlined />}
          style={{
            backgroundColor: isAgent ? fct.marca['verde-oscuro'] : fct.marca['verde-base'],
            marginRight: 8,
          }}
        />
        <Text strong style={{ fontSize: 13 }}>
          {message.senderName}
        </Text>
      </div>
      <div className={`message-bubble ${isAgent ? 'agent' : 'user'}`}>
        <Text style={{ whiteSpace: 'pre-wrap' }}>{message.text}</Text>
      </div>
      <div className="message-bubble-footer">
        <Text type="secondary" className="fct-mono" style={{ fontSize: 11 }}>
          {formatTime(message.timestamp)}
        </Text>
      </div>
    </div>
  );
};

export default MessageBubble;
